var map = {
	"./Union.svg": "481a",
	"./arrow-next.svg": "17f9",
	"./attach-file-icon.svg": "5b4c",
	"./calendar.svg": "b8bd",
	"./calendar_stat.svg": "a21b",
	"./checkbox.svg": "5b02",
	"./clock.svg": "755b",
	"./clock_stat.svg": "147b",
	"./cycle.svg": "250f",
	"./email-footer.svg": "08ed",
	"./facebook.svg": "8485",
	"./instagram.svg": "bd6c",
	"./linkedin.svg": "9ed9",
	"./location-footer.svg": "12b0",
	"./menu-arrow.svg": "3a7a",
	"./next-mobile.svg": "7c08",
	"./next-sm.svg": "4945",
	"./next.svg": "0043",
	"./people.svg": "1a5b",
	"./people_stat.svg": "6292",
	"./person.svg": "d104",
	"./phone.svg": "c3bb",
	"./prev-mobile.svg": "eb0c",
	"./prev-sm.svg": "8428",
	"./prev.svg": "ed83",
	"./smile.svg": "0c16",
	"./telegram.svg": "2b29",
	"./world.svg": "0257"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";